import { useMutation, useQueryClient } from 'react-query';

import { putInteractiveMapPlan } from 'api/InteractiveMap/putInteractiveMapPlan';

const usePutInteractiveMapPlan = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: putInteractiveMapPlanSwitch,
    isLoading,
  } = useMutation(putInteractiveMapPlan, {
    onSuccess: () => {
      queryClient.invalidateQueries('interactiveMapPlans');
    },
  });

  return {
    isSuccess,
    putInteractiveMapPlan: putInteractiveMapPlanSwitch,
    isLoading,
  };
};

export default usePutInteractiveMapPlan;
